__turbopack_context__.v({
  "accordionSlideOverwrite": "skeletonLoader-module-scss-module__EppFLa__accordionSlideOverwrite",
  "fadeIn": "skeletonLoader-module-scss-module__EppFLa__fadeIn",
  "fadeOut": "skeletonLoader-module-scss-module__EppFLa__fadeOut",
  "scaleIn": "skeletonLoader-module-scss-module__EppFLa__scaleIn",
  "scaleOut": "skeletonLoader-module-scss-module__EppFLa__scaleOut",
  "skeleton": "skeletonLoader-module-scss-module__EppFLa__skeleton",
  "skeletonContent": "skeletonLoader-module-scss-module__EppFLa__skeletonContent",
  "skeletonHeader": "skeletonLoader-module-scss-module__EppFLa__skeletonHeader",
  "skeletonLoader": "skeletonLoader-module-scss-module__EppFLa__skeletonLoader",
  "skeletonSubheader": "skeletonLoader-module-scss-module__EppFLa__skeletonSubheader",
  "skeletonText": "skeletonLoader-module-scss-module__EppFLa__skeletonText",
  "skeletonTextShort": "skeletonLoader-module-scss-module__EppFLa__skeletonTextShort",
  "zoomIn": "skeletonLoader-module-scss-module__EppFLa__zoomIn",
  "zoomOut": "skeletonLoader-module-scss-module__EppFLa__zoomOut",
});
